module.exports = __webpack_public_path__ + "static/media/stedelijk.25a0c582.jpg";